import { PRODUCT_INFO_SERVICE_URL } from 'product/constants/constants'
import { env } from 'utils/envManager/envManager'

type GetClientProductInfoParams = {
	countryISO: string
	languageISO: string
	productId: string
}

export const getClientProductInfoUrl = ({
	productId,
	countryISO,
	languageISO,
}: GetClientProductInfoParams) => {
	const searchParams = new URLSearchParams({
		channelId: env.NEXT_PUBLIC_CHANNEL,
		countryIso: countryISO,
		languageIso: languageISO,
		productId,
	})

	searchParams.sort()

	const url = new URL(
		PRODUCT_INFO_SERVICE_URL,
		env.NEXT_PUBLIC_ORCHESTRATOR_DOMAIN
	)

	url.search = searchParams.toString()

	return url.href
}
